import './stores/configureMobx'
import '../css/styles.scss'
import React, { Suspense } from 'react'
import { observer } from 'mobx-react'
import { createRoot } from 'react-dom/client'
import UnsupportedBrowser from 'components/UnsupportedBrowser'
import { Auth0Provider, useAuth0 } from '@auth0/auth0-react'
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom'
import Callback from './components/callback'
import ProtectedDashboard from './components/ProtectedDashboard'
import Login from './login'
import SharedImageScreen from './components/SharedImageScreen'
import bowser from 'bowser'
import i18n from './i18n'
import { I18nextProvider } from 'react-i18next'

const ObsI18nextProvider = observer(({ children, i18n }) => (
  <I18nextProvider i18n={i18n}>{children}</I18nextProvider>
))

const App = () => {
  const { isLoading, isAuthenticated } = useAuth0()
  const queryParams = new URLSearchParams(window.location.search)
  const plan = queryParams.get('plan')
  if (plan) {
    console.log('Target plan detected from Framer:', plan)
    sessionStorage.setItem('target_plan', plan)
    const promo = queryParams.get('promo')
    if (promo) {
      sessionStorage.setItem('target_promo', promo)
    } else {
      sessionStorage.removeItem('target_promo')
    }
  }
  const isUnsupported =
    (bowser.msie && bowser.version < 11) ||
    (bowser.chrome && bowser.version < 56) ||
    (bowser.firefox && bowser.version < 50) ||
    (bowser.safari && bowser.version < 10)
  if (isUnsupported) {
    return <UnsupportedBrowser />
  }

  const isSharedRoute = typeof window !== 'undefined' && window.location.pathname.startsWith('/shared')
  if (isLoading && !isSharedRoute) {
    return <div>Loading Page...</div>
  }
  const renderRoot = (props) => (
    isAuthenticated && props.location.pathname === '/' && sessionStorage.getItem('target_plan')
      ? <Redirect to='/callback' />
      : <ProtectedDashboard {...props} />
  )

  return (
    <>
      <ObsI18nextProvider i18n={i18n}>
        <Router>
          <Suspense fallback={<div>Loading Page...</div>}>
            <Switch>
              <Route exact path='/callback' component={Callback} />
              <Route exact path='/login' component={Login} />
              <Route exact path='/shared/:id' component={SharedImageScreen} />
              <Route path='/' render={renderRoot} />
            </Switch>
          </Suspense>
        </Router>
      </ObsI18nextProvider>
    </>
  )
}
const root = createRoot(document.getElementById('root'))
root.render(
  <Auth0Provider
    domain={process.env.AUTH0_DOMAIN}
    clientId={process.env.AUTH0_CLIENT_ID}
    redirectUri={process.env.REDIRECT_URI}
    audience={process.env.AUTH0_AUDIENCE}
    scope='openid profile email'
  >
    <App />
  </Auth0Provider>
)
